import { IListItemStylesProps } from './typings'

import { Theme } from '@mui/material/styles'

export const listStyles = {
  root: {
    display: 'inline-flex',
    flexDirection: 'row',
    padding: (theme: Theme) => theme.spacing(0),
  },
}

export const getListItemStyles = (props: IListItemStylesProps) => ({
  root: {
    marginLeft: props.marginLeft === undefined ? -1.2 : props.marginLeft / 10,
    padding: (theme: Theme) => theme.spacing(0),
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
    userSelect: 'none',

    svg: {
      transition: 'all 2s',
    },
  },
})

export const listItemLabelStyle = (
  color: string,
  height: number,
  padding: string,
): React.CSSProperties => {
  return {
    color: color,
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: 12,
    lineHeight: `${height}px`,
    width: `100%`,
    height: `${height}px`,
    padding: padding,
    position: 'absolute',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }
}

export const listItemEndAdornmentStyle = (
  right?: number,
  top?: number,
): React.CSSProperties => {
  return {
    display: 'inline-block',
    position: 'absolute',
    top: top ?? 0,
    right: right ?? 0,
  }
}

export const usePageButtonStyling = {
  root: {
    border: 'solid 1px #9a9a9a',
    minWidth: 33,
    height: 32,
    padding: (theme: Theme) => theme.spacing(0),

    '&:hover': {
      border: 'solid 1px #6a6a6a',
    },
  },
}

export const usePageButtonIconStyling = {
  root: {
    color: '#979797',
    width: 12,
    height: 12,
  },
}
